// extracted by mini-css-extract-plugin
export default {"wrapper":"MediaPreview_wrapper__TF7I0","item":"MediaPreview_item__hwzjW","details":"MediaPreview_details__9Gyk0"};